import { dossierTracks, featuredPost } from "@/mocks/homeContent";

const HERO_IMG =
  "https://readdy.ai/api/search-image?query=dark%20investigative%20editorial%20background%20of%20torn%20black%20paper%20with%20overlapping%20dossier%20documents%20and%20crimson%20red%20grunge%20ink%20streaks%2C%20scattered%20evidence%20scraps%20and%20charred%20edges%2C%20moody%20chiaroscuro%20lighting%2C%20deep%20blacks%20with%20amber%20and%20crimson%20accents%2C%20abstract%20cinematic%2C%20high%20contrast&width=1600&height=900&seq=hero-2026-69&orientation=landscape";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-foreground-950">
      <img
        src={HERO_IMG}
        alt="69黑料 深挖帖与扒皮现场 封面图"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/45 to-black/80" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-black/30" />

      <div className="relative mx-auto w-full max-w-[1280px] px-4 pb-16 pt-10 md:px-6 md:pb-24 md:pt-16">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[1.2fr_0.9fr] lg:gap-14">
          <div className="animate-rise-in">
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                <i className="ri-fire-fill animate-flame" />
                深挖帖 · 全程记录
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/10 px-3 py-1 text-xs font-medium text-background-100 ring-1 ring-background-50/20">
                <i className="ri-scissors-cut-line" />
                扒皮现场
              </span>
            </div>

            <h1 className="font-heading mt-6 text-3xl font-black leading-tight text-background-50 md:text-5xl">
              深挖帖扒皮现场，<br />
              黑历史起底<span className="text-primary-400">全程记录</span>
            </h1>

            <p className="mt-5 max-w-2xl text-[15px] leading-relaxed text-foreground-100 md:text-base">
              69黑料把散落在公开渠道的线索收拢成一条可复盘的主线：从黑历史挖掘到证据拼图，从口径拆解到内幕还原。
              每一份深挖帖都带现场热度与还原进度，想看深扒的细节与内幕，认准这里持续更新。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#dig"
                className="inline-flex whitespace-nowrap items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-400"
              >
                进入最新深挖帖
                <i className="ri-arrow-right-line" />
              </a>
              <a
                href="#timeline"
                className="inline-flex whitespace-nowrap items-center justify-center gap-2 rounded-md border border-background-50/30 bg-background-50/5 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/15"
              >
                查看事件还原脉络
              </a>
            </div>

            <div className="mt-7 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-200">
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-archive-2-line text-accent-400" /> 起底档案库 · 持续归档
              </span>
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-sparkling-line text-primary-400" /> 每周更新多份深挖帖
              </span>
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-verified-badge-line text-accent-400" /> 证据交叉核验
              </span>
            </div>
          </div>

          <div className="animate-rise-in lg:justify-self-end" style={{ animationDelay: "0.12s" }}>
            <div className="w-full max-w-md rounded-lg border border-background-50/15 bg-background-50/10 p-5 backdrop-blur-sm md:p-6">
              <div className="flex items-center justify-between border-b border-background-50/15 pb-3">
                <h3 className="flex items-center gap-2 text-sm font-bold text-background-50">
                  <span className="flex h-6 w-6 items-center justify-center rounded-md bg-accent-500/90 text-foreground-950">
                    <i className="ri-radar-line" />
                  </span>
                  深挖面板
                </h3>
                <span className="inline-flex items-center gap-1 rounded-full bg-background-50/10 px-2 py-0.5 text-[11px] text-foreground-100 ring-1 ring-background-50/15">
                  <span className="h-1.5 w-1.5 rounded-full bg-primary-400 animate-pulse-dot" />
                  {featuredPost.status}
                </span>
              </div>

              <ul className="mt-4 space-y-3">
                {dossierTracks.map((row) => (
                  <li key={row.label} className="flex items-center justify-between gap-3 text-[13px]">
                    <span className="text-foreground-300">{row.label}</span>
                    <span className={`font-semibold ${row.tone}`}>{row.value}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-5 border-t border-background-50/15 pt-4">
                <div className="mb-2 flex items-center justify-between text-xs">
                  <span className="text-foreground-200">本轮证据搜集进度</span>
                  <span className="font-semibold text-accent-400">78%</span>
                </div>
                <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-50/15">
                  <div className="h-full w-[78%] rounded-full bg-gradient-to-r from-primary-500 to-accent-500" />
                </div>
                <p className="mt-3 text-xs leading-relaxed text-foreground-300">
                  已完成 14 组证据归档、3 处口径拆解，还原链将随新线索自动续写。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}